import React from 'react';

function WelcomeSmall() {
  return (
    <section class="section-1">
        <div class="jumbotron d-flex align-items-center"  style={{height: 300}}>
            <div class="gradient"></div>
            <div class="container-fluid content">
                <h1 data-aos="fade-right" data-aos-delay="300">Laboratório de INteligência Artificial da UFPI</h1>
                <h2 data-aos="fade-left" data-aos-delay="300">Pesquisa e Inovação através de soluções em Inteligência Artificial</h2>
            </div>
        </div>
    </section>
  );
}

export default WelcomeSmall;